import type { FaireProductEntity } from "../../entity_types/product";

export const p_hbxhc5vk6t: FaireProductEntity = {
  token: "p_hbxhc5vk6t",
  type: "product",
  name: "Espresso Thanks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d954d312c906e0d5991c5260915972cd1ec02672c38cd61622c70d9da1c5a7bc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/52d52f95e3d3f6e87002150179b74bdda043985bfb9a0270579db1d54d1d1404.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:54.643Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
